import { Injectable, inject } from '@angular/core';

import { hasValue } from '@frontend/sports/common/core/utils/extended-types';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Widget, WidgetLayoutResponse, WidgetType } from '@frontend/sports/types/components/widget';
import { LinkListPayload } from '@frontend/sports/types/components/widget/types';

type TrackingData = Record<string, string | undefined>;

@Injectable({ providedIn: 'root' })
export class WidgetTrackingService {
    private trackingService = inject(TrackingService);

    trackWidgetsLoaded({ widgets, template, page }: WidgetLayoutResponse): void {
        const path = [template.folder, page, template.name].filter(hasValue).join('/');

        const trackingData = widgets?.map((w) => this.getTrackingData(path, w));

        const linkWidget = widgets?.find((x) => x.type === WidgetType.LinkList) as Widget<LinkListPayload> | undefined;
        if (linkWidget?.payload?.links) {
            for (const link of linkWidget.payload.links) {
                trackingData?.push(
                    this.getTrackingData(path, linkWidget, {
                        [trackingConstants.COMPONENT_SITECORE_ID]: link.sitecoreId,
                        [trackingConstants.COMPONENT_USER_SEGMENTS]: link.userSegmentGroups || NOT_APPLICABLE,
                    }),
                );
            }
        }

        this.trackingService.track(trackingConstants.SHOW_MODULE, {
            [trackingConstants.SHOW_MODULE]: trackingData,
        });
    }

    private getTrackingData<T>(path: string, widget: Widget<T>, additionalData?: TrackingData): TrackingData {
        return {
            ...widget.trackingData,
            [trackingConstants.COMPONENT_MODULE_NAME]: widget.type,
            [trackingConstants.COMPONENT_MODULE_POSITION]: `${widget.location}|${widget.order}`,
            [trackingConstants.COMPONENT_PAGE_LAYOUT]: path,
            [trackingConstants.COMPONENT_MODULE_CUSTOM_NAME]: widget.templateName,
            [trackingConstants.COMPONENT_MODULE_SOURCE]: 'standard module',
            [trackingConstants.COMPONENT_SITECORE_ID]: widget.sitecoreId,
            [trackingConstants.COMPONENT_USER_SEGMENTS]: widget.userSegmentGroups || NOT_APPLICABLE,
            ...additionalData,
        };
    }
}
